import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'policy-studio-match-box',
  templateUrl: './policy-studio-match-box.component.html',
  styleUrls: ['./policy-studio-match-box.component.less']
})
export class PolicyStudioMatchBoxComponent {

  @Input() item: any;

  constructor() {}

  isValueExists(value): boolean {
    return _.isArray(value) && value.length > 0;
  }

}
